import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to detect when a route transition is happening
 * Used with LinearProgress to show a loading bar during navigation
 * @returns {boolean} true if route change is in progress
 */
export function useRouteLoading() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return loading;
}
